import { createFileRoute } from '@tanstack/react-router';
import { AutomationPageView } from '@/components/marketing/AutomationPage';
import { automationHead } from '@/content/aiAutomation';
export const Route = createFileRoute('/ai-automation/receptionist')({head: () => automationHead('receptionist'), component: ReceptionistPage});
function ReceptionistPage() { return <AutomationPageView pageKey="receptionist" />; }